import { Badge, Row } from 'react-bootstrap'
import AdminButton, { AdminBtn } from './AdminButton'
import { FEATURES } from '../../../config/features'
import PageHeader from '../../layout/page/PageHeader'

const panel: AdminBtn[] = [
    {
        id: 1,
        label: 'Main Contacts',
        description: 'Manage primary contact details and enquiry recipients',
        icon: 'envelope',
        iconPrefix: 'far',
        link: '/administration/main-contacts',
        color: '#0a63ea',
        gradient: 'linear-gradient(135deg, #0a63ea, #083bb0)',
    },
    {
        id: 13,
        label: 'Email Templates',
        description: 'Design and customise automated email templates',
        icon: 'paper-plane',
        iconPrefix: 'far',
        link: '/administration/emails',
        color: '#6366f1',
        gradient: 'linear-gradient(135deg, #6366f1, #4f46e5)',
    },
    {
        id: 2,
        label: 'Social Media',
        description: 'Configure social media links and integrations',
        icon: 'comments',
        iconPrefix: 'far',
        link: '/administration/social-media-links',
        color: '#06b6d4',
        gradient: 'linear-gradient(135deg, #06b6d4, #0891b2)',
    },
    {
        id: 3,
        label: 'Languages',
        description: 'Add and manage supported languages',
        icon: 'globe',
        link: '/administration/languages',
        color: '#10b981',
        gradient: 'linear-gradient(135deg, #10b981, #059669)',
    },
    {
        id: 4,
        label: 'Currencies',
        description: 'Set up currencies and exchange rate options',
        icon: 'money-check-alt',
        link: '/administration/currencies',
        color: '#f59e0b',
        gradient: 'linear-gradient(135deg, #f59e0b, #d97706)',
    },
    {
        id: 5,
        label: 'Date & Time',
        description: 'Configure date formats and timezone preferences',
        icon: 'clock',
        iconPrefix: 'far',
        link: '/administration/date-and-time',
        featureKey: 'dateAndTime',
        color: '#f97316',
        gradient: 'linear-gradient(135deg, #f97316, #ea580c)',
        badge: (
            <Badge pill bg="warning" className="text-dark">
                Coming soon!
            </Badge>
        ),
    },
    {
        id: 6,
        label: 'Translations',
        description: 'Translate content across all supported languages',
        icon: 'language',
        link: '/administration/translations',
        color: '#8b5cf6',
        gradient: 'linear-gradient(135deg, #8b5cf6, #7c3aed)',
    },
    {
        id: 7,
        label: 'API Manager',
        description: 'Manage API keys, endpoints, and access control',
        icon: 'bolt',
        link: '/administration/api-manager',
        color: '#ef4444',
        gradient: 'linear-gradient(135deg, #ef4444, #dc2626)',
    },
    {
        id: 8,
        label: 'Users',
        description: 'Manage user accounts, roles, and permissions',
        icon: 'users-cog',
        link: '/administration/users',
        color: '#3b82f6',
        gradient: 'linear-gradient(135deg, #3b82f6, #2563eb)',
    },
    {
        id: 9,
        label: 'Navigation',
        description: 'Build and organise site navigation menus',
        icon: 'bars-staggered',
        link: '/administration/navigation',
        color: '#ec4899',
        gradient: 'linear-gradient(135deg, #ec4899, #db2777)',
    },
    {
        id: 10,
        label: 'Brand Identities',
        description: 'Configure logos, colours, and brand assets',
        icon: 'address-card',
        iconPrefix: 'far',
        link: '/administration/client/identity',
        color: '#14b8a6',
        gradient: 'linear-gradient(135deg, #14b8a6, #0d9488)',
    },
    {
        id: 11,
        label: 'Themes',
        description: 'Customise the visual theme and appearance',
        icon: 'paint-brush',
        link: '/administration/client/theme',
        color: '#a855f7',
        gradient: 'linear-gradient(135deg, #a855f7, #9333ea)',
    },
    {
        id: 12,
        label: 'Website Builder',
        description: 'Visually build and edit your website pages',
        icon: 'wrench',
        link: '/administration/website-builder',
        featureKey: 'websiteBuilder',
        color: '#64748b',
        gradient: 'linear-gradient(135deg, #64748b, #475569)',
        badge: (
            <Badge pill bg="danger">
                Under development!
            </Badge>
        ),
    },
]

const Home = () => {
    return (
        <div className="administration-home">
            <PageHeader
                header="Administration"
                icon="cogs"
                subtitle="Manage your system settings, users, and configurations"
            />
            <Row>
                {panel
                    .filter(
                        (item) =>
                            item.featureKey == null ||
                            FEATURES[item.featureKey]
                    )
                    .map((item) => (
                        <AdminButton
                            key={item.id}
                            {...item}
                        />
                    ))}
            </Row>
        </div>
    )
}

export default Home
